import {gql} from "@apollo/client";
import {ApolloClientQuery} from "./_setup";

const GET_USER_BRAND_SETTING = gql`
    query getUserBrandSetting($filter: BrandSettingFilterInput) {
        getUserBrandSetting(filter: $filter) {
            ... on UserBrandSetting {
                companyLogo
                companyLogoInverse
                companyLogoSmall
                companyLogoInverseSmall
                siteFavicon
                siteFaviconInverse
                companyName
                companyNameShort
                supportEmail
                companyAddress
                companySlogan
                copyRight
                timezone
                pushNotification
                facebookLink
                instaLink
                youtubeLink
                twitterLink
                linkedInLink
                domain
                defaultDomain
                aboutPage
                supportPage
                companyTermOfUseLink
                companyPrivacyPolicyLink
                companyReturnRefundPolicyLink
                companyRiskDisclosureLink
                companyTermOfBusinessLink
                legalDocument {
                    fullLink
                    isUsedForRegistration
                    isShowInLoginPage
                    registerType
                    loginType
                    name
                    displayName
                    #fullLink
                    tinyMce
                    linkWithDomain
                    pdf {
                        link
                        fileList
                    }
                }
                theme
                layout
                usernameCharacterLimit
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function getUserBrandSetting(filter) {

    const variables = {
        filter: {
            userid: filter?.userid || null,
            language: filter?.language || null
        },
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };
    const execute = await ApolloClientQuery(GET_USER_BRAND_SETTING, variables, false);

    return execute;
}